import CryptoJS from 'crypto-js';

// Define a secret key for encryption/decryption
const SECRET_KEY = '9f3f2cea26ccd91a343edd63d87200e3ef71d4438619a3b3c67d094dbfa70c03';

// Encrypt a value
const encrypt = (value: any): string => {
    return JSON.stringify(value);
    return CryptoJS.AES.encrypt(JSON.stringify(value), SECRET_KEY).toString();
};

// Decrypt a value
const decrypt = (cipherText: string): any => {
    return JSON.parse(cipherText);
    const bytes = CryptoJS.AES.decrypt(cipherText, SECRET_KEY);
    const decryptedValue = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedValue);
};

// Set an item in localStorage with encryption
export const setItem = (key: string, value: any): void => {
    try {
        const encryptedValue = encrypt(value);
        localStorage.setItem(key, encryptedValue);
    } catch (error) {
        console.error(`Error setting item in localStorage: ${error}`);
    }
};

// Get an item from localStorage with decryption
export const getItem = (key: string): any | null => {
    try {
        const encryptedValue = localStorage.getItem(key);
        return encryptedValue ? decrypt(encryptedValue) : null;
    } catch (error) {
        console.error(`Error getting item from localStorage: ${error}`);
        return null;
    }
};

// Remove an item from localStorage
export const removeItem = (key: string): void => {
    try {
        localStorage.removeItem(key);
    } catch (error) {
        console.error(`Error removing item from localStorage: ${error}`);
    }
};

// Clear all items from localStorage
export const clearStorage = (): void => {
    try {
        localStorage.clear();
    } catch (error) {
        console.error(`Error clearing localStorage: ${error}`);
    }
};

// Clear specific items from localStorage
export const clearSpecificItems = (keys: string[]): void => {
    try {
        keys.forEach(key => localStorage.removeItem(key));
    } catch (error) {
        console.error(`Error clearing specific items from localStorage: ${error}`);
    }
};
